"use client"
import { Icons } from "@/app/assets/assets";
import PrimaryBtn from "@/components/PrimaryBtn";
import Form from "@/HomeFeatures/Contact/Form";
import { useTheme } from "@/HomeFeatures/Context/ThemeContext";
import React from "react";

interface BannerProps {
  title: React.ReactNode;
  desc: React.ReactNode;
  buttonTitle: React.ReactNode;
}
const AiBanner = ({ title, desc, buttonTitle }: BannerProps) => {
  const { handleOpenQuote } = useTheme();
  return (
    <div
      className='flex flex-col lg:flex-row items-center gap-[40px] 
                justify-between w-[calc(100%_-_10%)] mx-auto max-w-[2500px]
                py-[60px]
                '
    >
      <div className='flex flex-col lg:gap-[15px] gap-[5px]'>
        <h1
          className='max-w-[18ch] justify-start text-white 
                        text-[length:var(--service-banner-title)] flex lg:gap-x-[20px] gap-x-[10px] items-center font-normal 
                        clash-font capitalize flex-wrap leading-[100%]'
        >
          {title}
        </h1>

        <p className='justify-start text-white/50 text-[length:var(--banner-para)] max-w-[90%] lg:max-w-[47ch] font-normal leading-[150%] tracking-tight py-4'>
          {desc}
        </p>
        <PrimaryBtn
          text={buttonTitle}
          iconSrc={Icons?.chevronBlue}
          onClick={() => handleOpenQuote()}
        />
      </div>
      <div className='flex w-full max-w-[670px] flex-col items-center'>
        <Form variant='dark' type='ai_forms' />
      </div>
    </div>
  );
};

export default AiBanner;
